import { OdataManager } from '@/api/odata/odata-manager';
import { Audit } from '@/api/model/interfaces';

export default class AuditOdata extends OdataManager<Audit> {}
